import { identityServiceApi } from '../../../../infra/identityApi.service';
import { ADMINISTRATION_API } from '../../../../common/constants/api';

export const createNewCounty = async (params) => {
    try {
        const res = await identityServiceApi({
            method: 'post',
            url: ADMINISTRATION_API.COUNTIES,
            data: {
                name: params.name,
            },
        });

        return {
            result: true,
            options: res.data,
        };
    } catch (e) {
        return { error: { errmsg: e.response?.data?.message } };
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/requests/create_new_county_request.js